export const projectIcons = [
  "folder",
  "people",
  "write",
  "card",
  "filter",
  "bag",
  "lamp",
  "wallet",
  "cloud",
  "rise",
  "branch",
  "chart",
  "store",
  "database",
  "tag",
  "data-line",
  "phone",
  "chat",
  "chart-bar",
  "world",
  "list",
  "rmb",
  "resume",
  "map",
  "headphone",
  "location",
  "horn",
  "building",
  "change",
  "letter",
  "security",
  "paper-plane",
  "cup",
  "pass",
  "spanner",
  "item"
]

export const projectColumns = [
  {
    label: "项目名称",
    value: "name"
  },
  {
    label: "创建人",
    value: "creator.name",
    width: 200
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const projectTemplateColumns = [
  {
    label: "项目模板名称",
    value: "name"
  },
  {
    label: "最后修改人",
    value: "creator.name",
    width: 200
  },
  {
    label: "最后修改时间",
    value: "createAt"
  }
]
